module.exports = __webpack_public_path__ + "img/dvlf_logo_medium_no_beta_transparent.8effd040.png";